module.exports = __webpack_public_path__ + "static/media/info-outline-blue.480bd2b4.svg";